function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, HTMLAttributes } from 'react';
import { Typography } from '../../Typography';
import { formatBonus } from '../helpers/formatBonus';
require("./ProductBonus.css");
var styles = {
  "Root": "ProductBonus-module-Root_zi-",
  "Text": "ProductBonus-module-Text_1Qz"
};
export const ProductBonus = ({
  value,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("button", _extends({
    className: styles.Root
  }, rest), /*#__PURE__*/React.createElement(Typography, {
    variant: "p3",
    className: styles.Text
  }, formatBonus(value)));
};